module.exports = __webpack_public_path__ + "img/icon_edit.154f8489.svg";